/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tags_Manager_Enable_Disable_TitleInputs */

const en_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enable/Disable`)
};

const fr_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Activer/Desactiver`)
};

const de_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktivieren/Deaktivieren`)
};

const it_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Abilita/Disabilita`)
};

const ru_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Включить/Выключить`)
};

const es_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Habilitar/Deshabilitar`)
};

const zh_cn2_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`启用/禁用`)
};

const ja_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`有効化/無効化`)
};

const hi_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`अक्षम सक्षम`)
};

const pt_pt2_tags_manager_enable_disable_title = /** @type {(inputs: Tags_Manager_Enable_Disable_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ativar/Desativar`)
};

/**
* | output |
* | --- |
* | "Enable/Disable" |
*
* @param {Tags_Manager_Enable_Disable_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const tags_manager_enable_disable_title = /** @type {((inputs?: Tags_Manager_Enable_Disable_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tags_Manager_Enable_Disable_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_tags_manager_enable_disable_title(inputs)
	if (locale === "de") return de_tags_manager_enable_disable_title(inputs)
	if (locale === "it") return it_tags_manager_enable_disable_title(inputs)
	if (locale === "ru") return ru_tags_manager_enable_disable_title(inputs)
	if (locale === "es") return es_tags_manager_enable_disable_title(inputs)
	if (locale === "zh-CN") return zh_cn2_tags_manager_enable_disable_title(inputs)
	if (locale === "ja") return ja_tags_manager_enable_disable_title(inputs)
	if (locale === "hi") return hi_tags_manager_enable_disable_title(inputs)
	if (locale === "pt-PT") return pt_pt2_tags_manager_enable_disable_title(inputs)
	return en_tags_manager_enable_disable_title(inputs)
});